import React, { useEffect } from "react";
import { Modal, Typography } from "antd";
import './ballonModal.less'
import PopAnimation from "../PopAnimation/PopAnimation";
import { useDispatch, useSelector } from "react-redux";
import 'Assets/styles/default/components/BalloonModal/index.less'
import { popBallon } from "redux/Reducers/PopBallon/VertemGiftApi";
import { getAvailableBallons } from "redux/Reducers/PopBallon/VertemGiftApi";

const HeroHeader = () => (
  <div className="rectangle-popBallon-top">
    <span className="txt-rectangle-top">Parabéns!<br />
      Você pode ganhar um prêmio.<br />
      Estoure o balão e boa sorte!
    </span>
  </div>
);

const Disclaimer = () => {
  const { availableBallons } = useSelector(state => state.VertemGift);

  return (
    <div className="rectangle-popBallon-footer">
      <p className="txt-rectangle-footer">
        Em maio, mês de aniversário do Acessa Agro, cada<br />
        resgate* te dá uma chance de ganhar um prêmio.<br />
        <br />
        <div>
          Você possui{" "}
          <strong className="ballon-counter">{availableBallons.length} {availableBallons.length === 1 ? 'Balão' : 'Balões'}</strong>{" "}
          {availableBallons.length === 1 ? 'disponível' : 'disponíveis'}.
        </div>
      </p>
    </div>
  )
}

const SideText = () => {
  return <span className="limited-pop">* Limitado a um regate por dia</span>
}

export const LegalText = () => {
  return (
    <div className="container-spa">
      <span>Promoção válida para Produtores Rurais cadastrados no Acessa Agro e que cumpram os critérios estabelecidos em
        regulamento, no período de 01/05/2024 a 31/05/2024. Consulte demais condições no regulamento. Certificado de
        autorização SPA/ME N°05.033167/2024.
      </span>
    </div>
  )
}

const ClickButton = () => {
  return (
    <div className="container-click-btn" >
      <img className="img-click-btn"
        src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/cta-min.png"
        alt="Clicar" />
    </div>
  )
}


const BalloonModal = ({ onClose }) => {
  const [animationStarted, setAnimationStarted] = React.useState(false);
  const { availableBallons } = useSelector(state => state.VertemGift);


  const handleAnimationStart = () => {
    if (availableBallons && availableBallons.length > 0) {
      setAnimationStarted(true);
    }
  };


  return (
    <Modal
      className="modal-action-pop-ballon"
      visible={true}
      onOk={onClose}
      onCancel={onClose}
      width={564}
      footer={<LegalText />}
    >
      {!animationStarted && <HeroHeader />}
      <div className="pop-animation-container">
        {!animationStarted && <ClickButton />}
        <PopAnimation onAnimationStart={handleAnimationStart} />
        {!animationStarted && <SideText />}
      </div>
      {!animationStarted && <Disclaimer />}
    </Modal>
  );
};

export default BalloonModal;
